export default {"src":"/_next/static/media/cor7.f494c285.svg","height":100,"width":183,"blurWidth":0,"blurHeight":0};